import { Component, computed, inject, model } from '@angular/core';
import { RepairTaskItemDto, RepairTaskService, SortDto } from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { loader } from '@/utils/signals/loader';

@Component({
  standalone: false,
  selector: 'wr-user-dashboard-repair-task-overview',
  templateUrl: './user-dashboard-repair-task-overview.component.html',
  styleUrls: ['./user-dashboard-repair-task-overview.component.scss'],
})
export class UserDashboardRepairTaskOverviewComponent {

  repairTaskService = inject(RepairTaskService);

  status = model<RepairTaskItemDto.StatusEnum | undefined>(undefined);

  overdue = model<boolean>(false);

  page = model<number>(0);
  pageSize = model<number>(10);
  sort = model<SortDto>({ sort: 'deadline', order: 'DESC' });

  isLoading = loader();

  result = asyncComputed(() => this.repairTaskService.getOwnRepairTasks({
    status: this.status(),
    overDue: this.overdue(),
    page: this.page(),
    size: this.pageSize(),
    sort: this.sort(),
  }), undefined, this.isLoading);

  repairTasks = computed(() => this.result()?.items ?? []);

  count = computed(() => this.result()?.totalItems ?? 0);

  readonly getInspectionLink = (repairTask: RepairTaskItemDto) => (['inspection', repairTask.inspectionEntry!.inspectionId, 'repair-tasks']);
}
